import React from "react";
import { Link } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { useState } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

const Header = () => {
  const { user, signOut } = useUser();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  }

  const handleSignOut = () => {
    signOut();
    closeMenu();
  }

  return (

    <header className='bg-primary text-white py-4 print:hidden'>
      <div className='container mx-auto px-4 sm:px-6 lg:px-8'>
        <nav className="flex md:block flex-wrap">
          <h1 className='text-3xl flex-1 order-2 font-bold text-center mb-4'>LetsCookTonight</h1>
          <div className="hidden md:flex justify-between">
            <div className="flex-1"></div>
            <div className="flex-1 flex justify-center space-x-4">
              <Link to="/recipes" className="font-sans text-white hover:underline">
                Recipes
              </Link>
              <Link to="/recipe/add" className="font-sans text-white hover:underline">
                Upload
              </Link>
            </div>
            <div className="flex-1 flex justify-end">
              {user ? (
                <div className="flex items-center space-x-3">
                  {user.photoUrl && (
                    <img
                      src={user.photoUrl}
                      alt={`${user.name || "User"}'s profile`}
                      className="h-10 w-10 rounded-full border-2 border-white object-cover"
                      referrerPolicy="no-referrer"
                    />
                  )}
                  {user.name && <span className="font-sans">{user.name}</span>}
                  <button className="text-white hover:underline px-2" onClick={signOut}>
                    Sign Out
                  </button>
                </div>
              ) : (
                <Link to="/signin" className="font-sans text-white hover:underline">
                  Sign In
                </Link>
              )}
            </div>
          </div>
          <div className="md:hidden flex-1">
            <button
              onClick={toggleMenu}
              className="text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
            >
              {isOpen ? (
                <XMarkIcon className="size-8 text-white" />
              ) : (
                <Bars3Icon className="size-8 text-white" />
              )}
            </button>
          </div>
          <div className="flex-1 order-3"></div>
          {/* Mobile Menu */}
          {isOpen && (
            <div className="md:hidden order-4 block w-full">
              <div className="px-2 pt-2 pb-3 sm:px-3 gap-2 flex flex-col">
                <Link to="/recipes" onClick={closeMenu} className="font-sans text-white hover:underline">
                  Recipes
                </Link>
                <Link to="/recipe/add" onClick={closeMenu} className="font-sans text-white hover:underline">
                  Upload
                </Link>
                {user ? (
                  <div>
                    <hr class="mb-2"/>
                    <div className="flex items-center gap-3">
                      {user.photoUrl && (
                        <img
                          src={user.photoUrl}
                          alt={`${user.name || "User"}'s profile`}
                          className="h-10 w-10 rounded-full border-2 border-white object-cover"
                          referrerPolicy="no-referrer"
                        />
                      )}
                      <div className="flex flex-col">
                        {user.name && <span className="font-sans">{user.name}</span>}
                        <button onClick={handleSignOut} className="text-left text-white hover:underline">
                          Sign Out
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <Link to="/signin" onClick={closeMenu} className="font-sans text-white hover:underline">
                    Sign In
                  </Link>
                )}
              </div>
            </div>
          )}
        </nav>
      </div>
    </header>
  )
}

export default Header;
